import script from "./mailshot-item-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./mailshot-item-modal.vue?vue&type=script&setup=true&lang=ts"

import "./mailshot-item-modal.vue?vue&type=style&index=0&id=616ebee1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-616ebee1"]])

export default __exports__